// A copy of LaunchDarkly's Google Cloud region rule
// (packages/integrations/launchdarkly/shared/src/gcp-hosting.ts), kept apart so that
// Miro (AI) changes no other integration.
//
// The shape of a Google Cloud region's name: words of lowercase letters
// joined by hyphens, then a number, as in `us-central1` and
// `northamerica-northeast2`. Nothing P0 has lists the regions Cloud Run is
// in, so this keeps out what can't be one, such as a zone (`us-central1-a`)
// or an AWS region (`us-west-2`), and takes a region that doesn't exist.
const GCP_REGION_PATTERN = /^[a-z]+(?:-[a-z]+)+\d+$/;

export const INVALID_GCP_REGION =
  "Enter the Google Cloud region the connector runs in, such as us-central1.";

/** Whether `region`, ignoring surrounding whitespace, has the shape of a
 * Google Cloud region's name. */
export const isGcpRegion = (region: unknown): region is string =>
  typeof region === "string" && GCP_REGION_PATTERN.test(region.trim());

// A Google Cloud project's ID, as the Miro (AI) connector takes one: it
// becomes a segment of the path the secret is read at. A copy of the pattern
// in the connector's `secretPointer`, which the backend's
// `src/__tests__/connector-contract.test.ts` holds this to.
const GCP_PROJECT_ID_PATTERN = /^[a-z][a-z0-9-]{4,28}[a-z0-9]$/;

/** Whether `projectId`, as it stands, is a Google Cloud project's ID: 6 to 30
 * lowercase letters, digits and hyphens, starting with a letter and not
 * ending with a hyphen. Not a project number, and not a project's name. */
export const isGcpProjectId = (projectId: string) =>
  GCP_PROJECT_ID_PATTERN.test(projectId);
